import { formatDate } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router, Event, NavigationEnd } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloModalSize } from 'src/app/core/halo-modal/halo-modal-interface';
import { HaloModalService } from 'src/app/core/halo-modal/halo-modal.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { MultiFacilityModel } from 'src/app/post-login/services/multi-facility.model';
import { MultiFacilityService } from 'src/app/post-login/services/multi-facility.service';
import { environment } from 'src/environments/environment';
import { Customization } from '../../video-library.model';
import { VideoLibraryService } from '../../video-library.service';
import { CustomizeBrandingService } from '../customize-branding.service';

@Component({
  selector: 'app-category-display-name',
  templateUrl: './category-display-name.component.html',
  styleUrls: ['./category-display-name.component.scss'],
})
export class CategoryDisplayNameComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('titleTemplate') titleTemplate: TemplateRef<any>;
  @ViewChild('action') action: TemplateRef<any>;
  @ViewChild('tooltipBanner', { static: false }) tooltipBanner: NgbTooltip;
  @ViewChild('facilitiesTemplate') facilitiesTemplate: TemplateRef<any>;
  cloudBasePath: string;
  commonUtil: CommonUtil;
  isChanged = false;
  showFooter = false;
  showErrorMessage = false;
  isEnabled = false;
  multiFacilities: MultiFacilityModel[];
  selectedFacilities: string[] = [];
  categoryName: FormControl = new FormControl('', [Validators.maxLength(50)]);
  currentUrl: string;
  isPublished = false;
  isOpenModalForPublish = false;
  hasFullPermission = false;
  selectedSingleSiteFacility: string;
  rootScopeData: RootScopeDeclare;
  timeUploaded = '';
  customizeData: Customization | any = {};
  facilitiesConsoleEquipmentsMap : any;
  facilityIds = [] as any;
  enabledEquipmentOnDemandNCustomLibrary = [] as any;
  private sub = new Subscription();
  constructor(
    private _router: Router,
    private _commonUtil: CommonUtil,
    private _multiFacilityService: MultiFacilityService,
    private _facilityService: FacilityService,
    private _modal: HaloModalService,
    private rootScopeService: RootScopeService,
    private _loader: HaloLoaderService,
    private _toast: HaloToastService,
    public customizeBrandingService: CustomizeBrandingService,
    private _vdoLibraryService: VideoLibraryService
  ) {
    this.commonUtil = this._commonUtil;
    const routerSub = this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (this._multiFacilityService.isMultifacilityUrl(event.url)) {
          this.currentUrl = event.url;
        }
      }
    });
    this.sub.add(routerSub);
  }
  ngAfterViewInit(): void {
    this.tooltipBanner.open();
  }

  async ngOnInit(){
    this.cloudBasePath = environment.cloudBasePath;
    this.getRootScopeData();
    const dataSub = this.customizeBrandingService.customizeDataSubscriber.subscribe((data) => {
      this.showFooter = false;
      this.customizeData = {categoryName: ''};
      this.categoryName.patchValue(this.customizeData.categoryName);
      if (data && !data.error_code) {
        if(data.data[0]) {
          this.customizeData = data.data[0].attributes;
        } else {
          this.customizeData = {}
          this.timeUploaded = '';
        }
        this.isChanged = true;
        this.isPublished = false;
        this.categoryName.patchValue(this.customizeData.categoryName);
        if(this.customizeData.categoryNameUpdatedOn) {
          this.timeUploaded = formatDate(this.customizeData.categoryNameUpdatedOn, 'MMM dd, yyyy HH:mm', 'en-US');
        } else {
          this.timeUploaded = ''
        }
      }
    });
    this.sub.add(dataSub);
    const categoryNameChangesSub = this.categoryName.valueChanges.subscribe((value: string) => {
      if (value !== this.customizeData.categoryName) {
        this.isChanged = true;
        this.showFooter = true;
        this.rootScopeData.isPageHasUnsavedChanges = true;
      }
      if (value !== '') {
        this.showErrorMessage = false;
      }
    });
    this.sub.add(categoryNameChangesSub);

    const lfAssetApiResp = await this._facilityService.get();
    if(lfAssetApiResp){
      this.facilitiesConsoleEquipmentsMap = lfAssetApiResp.facilities;
    }
  }

  getRootScopeData(): void {
    const getRpptScopeSub = this.rootScopeService
      .getRootScope()
      .subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
    this.sub.add(getRpptScopeSub);
  }

  cancel(): void {
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this._router.navigate(['/videoLibrary']);
  }

  next(): void {
    if (!this.isOpenModalForPublish) {
      if (this.isChanged && !this.categoryName.errors?.maxlength) {
        this.showLFODVideoTree();
      } else {
        this.showErrorMessage = true;
      }
      this.isOpenModalForPublish = true;
    }
  }

  cancelOnModal(): void {
    this._modal.close();
    this.isOpenModalForPublish = false;
  }

  async confirmOnModal() {
    const list = this.selectedFacilities.map((id) => +id);
    const payload = {
      categoryName: this.categoryName.value === '' ? null : this.categoryName.value,
      facilityIds: list,
      updatedBy: this.rootScopeData?.currentUser?.displayName,
    };
    this._loader.startProcess();
    try {
      await this.customizeBrandingService.saveCustomize(payload);
      this.showFooter = false;
      this.isPublished = true;
      this.isOpenModalForPublish = false;
      this._toast.creatToast(this._commonUtil.translateText('PUBLISHED.CATEGORY'));
      this.timeUploaded = formatDate(new Date(), 'MMM dd, yyyy HH:mm', 'en-US');
      this.rootScopeData.isPageHasUnsavedChanges = false;
    } catch (error) {}
    this.cancelOnModal();
    this._loader.endProcess();
  }

  onSelectedFacilityChanged(value:any): void {
    let fac = value.map((val:any) => val.facilityId);
    this.isEnabled = fac.length > 0;
    this.selectedFacilities = fac;
  }

  async showLFODVideoTree() {
    this._loader.startProcess();
    try {
      let defaultFacilities:any;
      let respMultiFacilities = await this._multiFacilityService.getMultiFacilities();
      respMultiFacilities = this.filter(JSON.parse(JSON.stringify(respMultiFacilities)));
      defaultFacilities = this.selectDefault(respMultiFacilities);
  
      /* Start Here , Below code make facility check option to be disiabled based on the isCustomLibraryEnabledCount */
      this.facilityIds = [];
      let data = [] as any;
      this.getFacilityIds(defaultFacilities);     
      let tmp_1 = await this._vdoLibraryService.getEnabledOnDemandClasses(this.facilityIds).toPromise();
      let tmp_2 =  Object.entries(tmp_1) as any;
      let se4ConsolesTypes = ['hal','everest','neo_se4','falco'];
      tmp_2.forEach((ele:any) => {
        if(JSON.stringify(ele) !== "{}"){
          let eqStatus = Object.values(ele[1]) as any;      
          let obj = {
            "facilityId": ele[0],
            "isLFODEnabledCount": eqStatus.find((val:any) => val.lfodenabledCount>0)?true:false,
            "isSe4LFODEnabledCount": eqStatus.find((val:any) => se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false,
            "isSe3LFODEnabledCount": eqStatus.find((val:any) => !se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false,
            "isCustomLibraryEnabledCount" : eqStatus.find((val:any) => val.customLibraryEnabledCount>0)?true:false
          }   
          data.push(obj);
        }
      });
  
      this.enabledEquipmentOnDemandNCustomLibrary = data;
      this.multiFacilities = this.updateIsEnabledStatus(defaultFacilities);
      /* End Here */
  
      this._modal.add({
        dismissible: true,
        titleUppercase: true,
        modalSize: HaloModalSize.Medium,
        titleTemplate: this.titleTemplate,
        footerTemplate: this.action,
        bodyTemplate: this.facilitiesTemplate,
        isVideoTree: false,
      });
    } catch (error) {
      console.error('API failed.');
    }
    this._loader.endProcess();
  }

  updateIsEnabledStatus(facilities: MultiFacilityModel[]) {
    facilities?.forEach((facility) => {
      let fac = this.facilitiesConsoleEquipmentsMap.find((fConsole : any) => fConsole.facilityId === facility.facilityId);
      let tmp = this.enabledEquipmentOnDemandNCustomLibrary.find((val:any) => val.facilityId === facility.facilityId);
      if(fac.summary.userRights.customLibrary === "F"){
        if(tmp && tmp.facilityId){
          if(tmp.isCustomLibraryEnabledCount === true){
            facility.isEnabled = true;
          }else{
            facility.isEnabled = false;
          }
        }
      }else{
        facility.isEnabled = false;
      }     
      this.updateIsEnabledStatus(facility.children);
    });
    return facilities;
  }

  getFacilityIds(facilities: MultiFacilityModel[]) {
    facilities?.forEach((fac) => {
      this.facilityIds.push(Number(fac.facilityId));
      this.getFacilityIds(fac.children);
    });
    return facilities;
  }

  filter(facilities: MultiFacilityModel[]) {
    let filteredFacs: MultiFacilityModel[] = [];
    facilities?.forEach((facility) => {
      facility.children = this.filter(facility.children);
      facility.isEnabled = this.isValidLFODSupportFacility(facility);
      if (facility.isEnabled || this.hasLFODEnabledChildren(facility)) {
        filteredFacs.push(facility);
      }
    });
    return filteredFacs;
  }

  hasLFODEnabledChildren(facModel: MultiFacilityModel) {
    if (!facModel || !facModel.children) return false;
    for (let child of facModel.children) {
      if (child?.isEnabled || this.hasLFODEnabledChildren(child)) return true;
    }
    return false;
  }

  isValidLFODSupportFacility(facilityData: MultiFacilityModel) {
    return facilityData
      ? this._multiFacilityService.isMultifacilitySupported(this.currentUrl ?? this._router.url, facilityData)
      : false;
  }

  selectDefault(facilities: MultiFacilityModel[]) {
    facilities?.forEach((facility) => {
      let selectedFacility = this._facilityService.selectedMultiFacilities();
      let isValidLFODSup = this.isValidLFODSupportFacility(facility);
      if (selectedFacility.findIndex((f) => f === facility.facilityId) > -1 && isValidLFODSup) {
        facility.isSelected = true;
        facility.isDisabledSelectedFacility = true;
        this.selectedSingleSiteFacility = facility.facilityId;
      } else {
        facility.isSelected = false;
        facility.isDisabledSelectedFacility = false;
      }
      let fac = this.facilitiesConsoleEquipmentsMap.find((fConsole : any) => fConsole.facilityId === facility.facilityId);
      if(fac.summary.userRights.customLibrary !== "F"){
        facility.isEnabled = false;
      }
      this.selectDefault(facility.children);
    });
    return facilities;
  }

  onPermissionChange(value:boolean){
    this.hasFullPermission = value;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
